<!-- 视频 -->
<template>
    <div v-if="componentsData.type == 6"
        :style="`
            padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px; background: ${componentsData.content.bg_color};
            border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;
        `"
    >
        <div
            :style="
                componentsData.content.height_id == 1
                    ? 'height: 375px;'
                    : componentsData.content.height_id == 2
                    ? 'height: 187.5px;'
                    : componentsData.content.height_id == 3
                    ? 'height: 281.25px;'
                    : componentsData.content.height_id == 4
                    ? 'height: 500px;'
                    : componentsData.content.height_id == 5
                    ? 'height: 750px;'
                    : 'height: 375px;'
            "
        >
            <video class="w100" :src="componentsData.content.videoList.picview"></video>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.w100 {
    width: 100%;
    height: 100%;
}
</style>